import {getLoanStatusDisplay} from "../../Library/Braillers/BraillerLoanManagement/braillerLoanManagementUtility";
import type {BraillerPackingList} from "../packingList.types";

export const braillerPackingListModel = ({
                                             shipAddressFormatted,
                                             dateCreatedFormatted,
                                             patron,
                                             braillerCatalogItem,
                                             braillerLoanStatus,
                                             inventoryBarCode,
                                             shipDate = "",
                                         }: Record<string, any> = {}): BraillerPackingList => ({
    shipAddressFormatted,
    dateCreatedFormatted,
    patron,
    braillerCatalogItem,
    braillerLoanStatus,
    braillerLoanStatusText: getLoanStatusDisplay(braillerLoanStatus),
    inventoryBarCode,
    shipDate,
});
